export const USDC_DECIMALS = 6;
